import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=9265d084&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=js"
export * from "./invoice.vue?vue&type=script&lang=js"
import style0 from "./invoice.vue?vue&type=style&index=0&id=9265d084&prod&scoped=true&lang=css"
import style1 from "./invoice.vue?vue&type=style&index=1&id=9265d084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9265d084",
  null
  
)

export default component.exports